import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
//UI
import { DangerButton, InfoButton, SuccessButton, WarningButton } from "../../../../ui/buttons/Button";
import { Checkbox, Input, SearchInput, Textarea } from "../../../../ui/inputs/Input";
import { Mensaje, MensajeSiNo2 } from "../../../mensajes2";
import { Dimmer } from "../../../spinner";
import CatalogoPersona from "../../../../catalogos/catalogoPersona";
import axios from "axios";
import { validaSoloNumero } from "../../../../util/varios";
import CatalogoUbicacionBien from "../../../../catalogos/catalogoUbicacionBien";
const op = require("../../../../modulos/datos");

export default function UbicacionesBienes({ show, setShow, setTabla }) {
  const token = localStorage.getItem("jwtToken");

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtCodigo = useRef();
  const txtRif = useRef();
  const txtNombresApellidos = useRef();
  const txtDescripcion = useRef();
  const txtId = useRef();
  const txtCodigo1 = useRef();
  const txtCodigo2 = useRef();
  const txtCodigo3 = useRef();
  const fisica = useRef();

  const [operacion, setOperacion] = useState(0);
  const [activate, setActivate] = useState(false);
  const [visibleButton, setVisibleButton] = useState(true);
  const [disabled, setDisabled] = useState(true);
  const [mostrarCatalogo, setMostrarCatalogo] = useState(false);
  const [mostrarCatalogoResponsable, setMostrarCatalogoResponsable] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  const procesarRegistro = async (body) => {
    setActivate(true);
    const endpoint = `${op.conexion}/api/bienes/ubicacion/actualizar`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                response.data.ubicacionbien_act +
                " procesado correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                response.data.ubicacionbien_act +
                " modificado correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                response.data.ubicacionbien_act +
                " eliminado correctamente",
              icono: "exito",
            });
          }
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response) {
          mensaje = error?.response?.data?.message;
        } else {
          mensaje = error.toString();
        }

        if (
          mensaje ===
          `duplicate key value violates unique constraint "ubicacionbien_pkey"`
        ) {
          mensaje = "Ya Existe una Ubicacion con ese codigo.";
        }

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const onChangeValidar = async () => {
    let sigue = true;

    if (operacion !== 1 && txtId.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar la ubicacion.`,
        icono: "informacion",
      });
      sigue = false;
      txtId.current.focus();
    } else if (txtCodigo.current.value === "" || txtCodigo1.current.value === "" || txtCodigo2.current.value === "" || txtCodigo3.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar el codigo de ubicacion.`,
        icono: "informacion",
      });
      sigue = false;
      if (txtCodigo.current.value === "") {
        txtCodigo.current.focus();
      } else if (txtCodigo1.current.value === "") {
        txtCodigo1.current.focus();
      } else if (txtCodigo2.current.value === "") {
        txtCodigo2.current.focus();
      } else if (txtCodigo3.current.value === "") {
        txtCodigo3.current.focus();
      }
    } else if (txtDescripcion.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar la descripcion.`,
        icono: "informacion",
      });
      sigue = false;
      txtDescripcion.current.focus();
    } else if (txtRif.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar la cedula del responsable.`,
        icono: "informacion",
      });
      sigue = false;
      txtRif.current.focus();
    }

    if (sigue) {
      let codigoubicacion = txtCodigo.current.value.trim() +
        txtCodigo1.current.value.trim() +
        txtCodigo2.current.value.trim() +
        txtCodigo3.current.value.trim();
      const datos = {
        operacion: operacion,
        nid: txtId.current.value === "" ? "0" : txtId.current.value.trim(),
        codigo: codigoubicacion,
        descr: txtDescripcion.current.value.trim().toUpperCase(),
        ubifi: fisica.current.checked,
        cedres: txtRif.current.value.trim(),
      };

      await procesarRegistro({
        datos: datos,
      });
    }
  };

  const seleccionarUbicacion = async (idubi) => {
    const campos = "*";
    const nomtab = "ubicacionbien";
    const nomid = "idubicacionbien";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${idubi}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            txtId.current.value = data.idubicacionbien;
            txtCodigo.current.value = data.codigoubicacion.substring(0, 2);
            txtCodigo1.current.value = data.codigoubicacion.substring(2, 4);
            txtCodigo2.current.value = data.codigoubicacion.substring(4, 6);
            txtCodigo3.current.value = data.codigoubicacion.substring(6, 8);
            fisica.current.checked = data.ubicacionfisica;
            txtDescripcion.current.value = data.descripcionubicacionbien.trim();
            txtRif.current.value = data.cedularesponsable;
            await seleccionarResponsable(data.cedularesponsable);
          } else {
            setActivate(false);
            txtRif.current.value = "";
            txtNombresApellidos.current.value = "";
            txtRif.current.focus();
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe una Ubicación con este número de código.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarResponsable = async (cedulares) => {
    const campos = "*";
    const nomtab = "persona";
    const nomid = "cedula";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${cedulares}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            txtNombresApellidos.current.value = data.nombres.trim() + " " + data.apellidos.trim();
            setActivate(false);
          } else {
            setActivate(false);
            txtRif.current.value = "";
            txtNombresApellidos.current.value = "";
            txtRif.current.focus();
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe un Responsable con este número de cédula/Rif.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    txtCodigo.current.value = "";
    txtCodigo1.current.value = "";
    txtCodigo2.current.value = "";
    txtCodigo3.current.value = "";
    fisica.current.checked = false;
    txtDescripcion.current.value = "";
    txtRif.current.value = "";
    txtNombresApellidos.current.value = "";
    txtId.current.value = "";
    setOperacion(0);
    setVisibleButton(true);
    setDisabled(true);
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setMensajesino({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });

    setActivate(false);
  };

  const onClickButton = async (value) => {
    if (value === 1) {
      setOperacion(1);
      setVisibleButton(false);
      setDisabled(false);
    } else if (value === 2) {
      setOperacion(2);
      setVisibleButton(false);
    } else if (value === 3) {
      setOperacion(3);
      setVisibleButton(false);
    } else if (value === 4) {
      setOperacion(4);
      setVisibleButton(false);
    } else if (value === 5) {
      setVisibleButton(false);
      await onChangeValidar();
    } else if (value === 6) {
      blanquear();
    }
  };

  const onHideResponsalbe = (value) => {
    setMostrarCatalogoResponsable(false);
    if (value) {
      txtRif.current.value = value;
      seleccionarResponsable(value);
    }
  };

  const onHideUbicacion = (value) => {
    setMostrarCatalogo(false);
    if (value) {
      txtId.current.value = value;
      seleccionarUbicacion(value);
    }
  };

  const validarRif = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtRif.current.blur();
        seleccionarResponsable(event.target.value);
      } else {
        txtRif.current.value = "";
        txtNombresApellidos.current.value = "";
        txtRif.current.focus();
      }
    }
  };

  const validarCodigo = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Ubicación del Bien</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
        <div className="col-4 m-0 mb-2 p-0">
          <SearchInput
            ref={txtId}
            disabled
            label="CÓDIGO UBICACIÓN:"
            name="id"
            onClickButton={() => setMostrarCatalogo(true)}
            disabledButton={operacion === 0 || operacion === 1 ? true : false}
          />
        </div>
        <fieldset className="col-12 m-0 mb-2 p-2 d-flex gap-2 border-azul rounded">
          <legend className="float-none w-auto m-0">Código de Ubicación</legend>
          <div className="col m-0 p-0">
            <Input
              disabled={operacion === 1 || operacion === 2 ? false : true}
              ref={txtCodigo}
              label="ORG:"
              maxLength={2}
              onKeyUp={validarCodigo}
              onBlur={validarCodigo}
            />
          </div>
          <div className="col m-0 p-0">
            <Input
              disabled={operacion === 1 || operacion === 2 ? false : true}
              ref={txtCodigo1}
              label="DIRE:"
              maxLength={2}
              onKeyUp={validarCodigo}
              onBlur={validarCodigo}
            />
          </div>
          <div className="col m-0 p-0">
            <Input
              disabled={operacion === 1 || operacion === 2 ? false : true}
              ref={txtCodigo2}
              label="COORDI:"
              maxLength={2}
              onKeyUp={validarCodigo}
              onBlur={validarCodigo}
            />
          </div>
          <div className="col m-0 p-0">
            <Input
              disabled={operacion === 1 || operacion === 2 ? false : true}
              ref={txtCodigo3}
              label="UBI:"
              maxLength={2}
              onKeyUp={validarCodigo}
              onBlur={validarCodigo}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Checkbox label='Ubicación Fisica' disabled={operacion === 1 || operacion === 2 ? false : true} ref={fisica} id='ubicacionFisica' />
          </div>
        </fieldset>
        <diva className='col-12 m-0 mb-2 p-0'>
          <Textarea label='Descripción:' disabled={operacion === 1 || operacion === 2 ? false : true} ref={txtDescripcion} style={{ height: 70 }} />
        </diva>
        <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
          <legend className="float-none w-auto m-0">Responsable</legend>
          <div className="col-4 m-0 p-0">
            <SearchInput
              ref={txtRif}
              disabled={operacion === 1 || operacion === 2 ? false : true}
              onKeyUp={validarRif}
              onBlur={validarRif}
              label="Cédula/Rif:"
              name="rif"
              onClickButton={() => setMostrarCatalogoResponsable(true)}
              disabledButton={operacion === 1 || operacion === 2 && txtId.current.value !== "" ? false : true}
            />
          </div>
          <Input
            disabled={operacion === 1 || operacion === 2 ? false : true}
            ref={txtNombresApellidos}
            label="Nombre:"
          />
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        {visibleButton ? (
          <div className="col-12 d-flex m-auto justify-content-between">
            <SuccessButton onClick={() => onClickButton(1)} icon="fas fa-plus">
              Incluir
            </SuccessButton>
            <InfoButton onClick={() => onClickButton(4)} icon="fas fa-search">
              Consultar
            </InfoButton>
            <WarningButton onClick={() => onClickButton(2)} icon="fas fa-edit">
              Editar
            </WarningButton>
            <DangerButton onClick={() => onClickButton(3)} icon="fas fa-trash">
              Eliminar
            </DangerButton>
          </div>
        ) : (
          <div className="col-12 d-flex m-auto justify-content-end">
            <div className="m-1 p-0">
              <SuccessButton
                disabled={operacion === 4}
                ref={btnAcepta}
                onClick={() => onClickButton(5)}
              >
                Aceptar
              </SuccessButton>
            </div>
            <div className="m-1 p-0">
              <DangerButton ref={btnCancela} onClick={() => onClickButton(6)}>
                Cancelar
              </DangerButton>
            </div>
          </div>
        )}
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
        }}
      />
      <MensajeSiNo2
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <CatalogoPersona
        show={mostrarCatalogoResponsable}
        onHideCancelaCatPer={() => setMostrarCatalogoResponsable(false)}
        onHideAceptaCatPer={onHideResponsalbe}
      />
      <CatalogoUbicacionBien
        show={mostrarCatalogo}
        onHideCancelar={() => setMostrarCatalogo(false)}
        onHideAceptaCatalogo={onHideUbicacion}
      />
    </Modal>
  );
}
